import $ from 'jquery';
import slick from 'slick-carousel';

$(function () {

    $(".slider__arrows-prev").on("click", function (event) {
        let slider = $(this).data('slick-arrows-for');
        $(slider).slick('slickPrev');
    });

    $(".slider__arrows-next").on("click", function (event) {
        let slider = $(this).data('slick-arrows-for');
        $(slider).slick('slickNext');
    });

    let mobileSlider = $('[data-mobile-slider]');
    let mobileSliderBreakpoint = 768;

    let mobileSliderSettings = {
        initialSlide:   0,
        slidesToShow:   2,
        slidesToScroll: 1,
        infinite:       true,
        arrows:         false,
        dots:           false,
        autoplay:       false,
        autoplaySpeed:  5000,
        responsive:     [
            {
                breakpoint: 576,
                settings:   {
                    fade:         true,
                    slidesToShow: 1
                }
            }
        ]
    }
    mobSlider(mobileSlider, mobileSliderSettings, mobileSliderBreakpoint);

    let mobileSliderArrows = $('[data-mobile-slider-arrows]');

    let mobileSliderArrowsSettings = {
        initialSlide:   0,
        slidesToShow:   2,
        slidesToScroll: 1,
        infinite:       true,
        arrows:         true,
        dots:           false,
        autoplay:       false,
        autoplaySpeed:  5000,
        responsive:     [
            {
                breakpoint: 576,
                settings:   {
                    fade:         true,
                    slidesToShow: 1
                }
            }
        ]
    }
    mobSlider(mobileSliderArrows, mobileSliderArrowsSettings, mobileSliderBreakpoint);

    function mobSlider(slider, settings, breakpoint) {
        if (window.innerWidth > breakpoint) {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
            return
        }
        if (!slider.hasClass('slick-initialized')) {
            return slider.slick(settings);
        }
    }

    let doIt;

    function resizeWindow() {
        mobSlider(mobileSlider, mobileSliderSettings, mobileSliderBreakpoint);
    }

    window.onresize = function () {
        clearTimeout(doIt);
        doIt = setTimeout(function () {
            resizeWindow();
        }, 100);
    };
});

